import React, { useMemo } from 'react';
import { IRegionShort, IRelatedForRegion } from 'api/region/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { isMainLocale } from 'util/i18nFlags';
import { HeroNav } from 'components/common/HeroNav';
import { IResortPathInfo } from 'api/resort/types';
import {
  CurrentLink, CurrentTab, linksPlan, linksSnow,
} from './constants';

export const RegionHeaderNav = ({
  region, title, photo, link, resort,
}: {
  region: IRegionShort,
  title: string,
  photo: string,
  tab: CurrentTab,
  link: CurrentLink,
  related: IRelatedForRegion,
  resort: IResortPathInfo
}) => {
  const { t } = useOTSTranslation('common');

  // const { current: related } = useFakeQueryWithInitialValue(['region-related', region.uuid], () => fetchRegionRelated(region.uuid), preRelated);

  const linksSnowPart = useMemo(() => linksSnow(region, t), [region, t]);
  const linksPlanningPart = useMemo(
    () => (isMainLocale() ? linksPlan(region, t) : null),
    [region, t],
  );

  return (
    <div>
      <HeroNav
        title={title}
        backgroundPhoto={photo}
        links={[...linksSnowPart, ...linksPlanningPart || []]}
        link={link}
        resort={resort}
      />
    </div>

  );
};
